module.exports = __webpack_public_path__ + "img/browser-stats.734f5983.svg";